<template>
  <div class="publications-by-source-and-gsm">
    <ul class="publications-by-source-and-gsm__header">
      <li class="publications-by-source-and-gsm__title">
        {{chartTitle}}
      </li>
      <li class="publications-by-source-and-gsm__tools" v-if="!dataEmpty">
        <el-button type="text" class="publications-by-source-and-gsm__tools-button" :disabled="saveChart" @click="onSave">
          <i class="material-icons color_grey">save</i>
        </el-button>
        <el-button type="text" class="publications-by-source-and-gsm__tools-button" v-if="!isEdit" @click="editChart">
          <i class="material-icons color_grey">edit</i>
        </el-button>
      </li>
    </ul>
    <el-card shadow="hover" class="publications-by-source-and-gsm__card" v-loading="pending">
      <publications-by-source-and-gsm-header :chart-name="name"/>
      <template v-if="!dataEmpty">
        <publications-by-source-and-gsm-body
          :data="data"
          :chart-name="name"
          :save-chart="saveChart"
          :title="chartTitle"
          @onSavedChart="handleSaved"
          @onSaveChart="handleSave"
        />
      </template>

      <template v-else>
        {{$t('feed.analytics.bySourceAndGsm.noData')}}.
      </template>

    </el-card>
  </div>
</template>

<script>
// config
import { social } from "../../../../../../../config/sourceShortcuts";

// mixins
import { analytics } from "../../../../../../../mixins/analytics";

// vuex
import { mapGetters } from "vuex";

// components
import PublicationsBySourceAndGsmHeader from "./header/PublicationsBySourceAndGsmHeader";
import PublicationsBySourceAndGsmBody from "./body/PublicationsBySourceAndGsmBody";

export default {
  name: "PublicationsBySourceAndGsm",
  data() {
    return {
      name: "PublicationsBySourceAndGsm",
      format: "YYYY-MM-DD HH:mm:ss",
      saveChart: false
    };
  },
  computed: {
    ...mapGetters([
      "socialList",
    ]),
    sourceOf() {
      let sourceOf = [];

      let social = this.$t('feed.analytics.bySourceAndGsm.social');
      if (Object.keys(social.items).some(item => Object.keys(this.data).includes(item) && this.socialList.includes(item))) {
        sourceOf.push(social.name);
      }

      if (Object.keys(this.data).includes(social.excluded.name) && this.socialList.includes(social.excluded.name)) {
        sourceOf.push(social.excluded.title);
      }

      return  sourceOf;
    },
    chartTitle() {
      return  `${this.$t('feed.analytics.bySourceAndGsm.title')}: ${this.sourceOf.join(", ")}`;
    },
  },
  mixins: [
    analytics
  ],
  components: {
    PublicationsBySourceAndGsmHeader,
    PublicationsBySourceAndGsmBody
  }
};
</script>

<style>
  .publications-by-source-and-gsm {
    margin-bottom: 40px;
  }
  .publications-by-source-and-gsm__header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .publications-by-source-and-gsm__title {
    margin-bottom: 20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #5E6D82;
  }

  .publications-by-source-and-gsm__tools .material-icons {
    font-size: 16px;
  }

  .publications-by-source-and-gsm__tools {
    margin-top: 4px;
    margin-right: 15px;
  }

  .publications-by-source-and-gsm__tools-button {
    padding: 0;
    color: #5e6d82;
  }

  .publications-by-source-and-gsm__tools-button:hover {
    color: #B3BCCC;
    font-size: 12px;
  }
  @media screen and (max-width: 480px) {
    .publications-by-source-and-gsm__card {
      overflow-x: auto;  }
    .publications-by-source-and-gsm__tools {
      display: none;
    }
  }
</style>
